// extracted by mini-css-extract-plugin
module.exports = {"pc-feedback":"feedback_pc-feedback__X3sd2"};